module.exports = __webpack_public_path__ + "img/banner-r-r.a39902ae.png";